module.exports = __webpack_public_path__ + "img/tree-nuts.4c040111.svg";